module.exports = __webpack_public_path__ + "static/diane-allen-jones-4c81c4f5ba45983e8c3b8ab623dd5f14.jpg";